module.exports = __webpack_public_path__ + "img/h5-btn02.fff98e65.png";